import type { AssessmentResultsDocument } from '../model/types/assessment-results/interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { useDisciplineStore } from '@entities/customer/@x/assessment'
import { useCsRoutes } from '@shared/api'
import { isNotFoundError, show404, showRequestError } from '@shared/lib/page-error'

import { useAssessmentResultsStore } from '../model/assessment-results-store'

interface AssessmentResultsDocumentApiReturn {
  fetchAssessmentResult: (assessmentId: number, mode: ScopeMode) => Promise<void>
}

export const useAssessmentResultsDocumentApi = (): AssessmentResultsDocumentApiReturn => {
  const { $axios } = useNuxtApp()
  const assessmentResultsStore = useAssessmentResultsStore()
  const disciplineStore = useDisciplineStore()

  const requestResult = async (url: string): Promise<AssessmentResultsDocument> => {
    const { data } = await $axios.get(url)

    return data?.data as AssessmentResultsDocument
  }

  const fetchAssessmentResult = async (assessmentId: number, mode: ScopeMode): Promise<void> => {
    const disciplineId = disciplineStore.activeDiscipline?.id

    if (!disciplineId) {
      console.warn('missing disciplineId for assessment-results/show.hook.ts')

      return
    }

    const url = useCsRoutes('disciplines.assessment-result', {
      '[discipline_id]': disciplineId,
      '[assessment_id]': assessmentId,
    })

    if (!url) {
      console.warn('missing url for assessment-results/show.hook.ts')

      return
    }

    const requestId = assessmentResultsStore.beginResult(assessmentId, mode)

    try {
      assessmentResultsStore.settleResult(assessmentId, requestId, await requestResult(url))
    } catch (err: unknown) {
      console.error('unable to retrieve assessment-results/show.hook.ts:', err)

      assessmentResultsStore.failResult(assessmentId, requestId)

      if (isNotFoundError(err)) show404()
      else showRequestError()
    }
  }

  return { fetchAssessmentResult }
}
